import { render } from "./rent.vue?vue&type=template&id=640ec624"
import script from "./rent.vue?vue&type=script&lang=js"
export * from "./rent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__